export enum IncreamentErrors {
    NoStock = 'insufficient_stock',
}
